import { render, staticRenderFns } from "./foodDetail.vue?vue&type=template&id=01c6521c&scoped=true"
import script from "./foodDetail.vue?vue&type=script&lang=js"
export * from "./foodDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=01c6521c&prod&scoped=true&lang=css&external"
import style1 from "./foodDetail.vue?vue&type=style&index=1&id=01c6521c&prod&scoped=true&lang=css"
import style2 from "./foodDetail.vue?vue&type=style&index=2&id=01c6521c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6521c",
  null
  
)

export default component.exports